module.exports = __webpack_public_path__ + "files/1cf1a34c2376b282082522a244d8d4be.png";